import { useState } from "react";
import { treatments } from "@/mocks/home";

export default function SectionTreatments() {
  const [openId, setOpenId] = useState<string>(treatments[0].id);

  return (
    <section id="treatments" className="relative py-space-ds-section-standard md:py-space-ds-section-standard-md bg-white">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1440px] mx-auto">
          <div className="flex items-end justify-between mb-12">
            <div>
              <div className="text-ds-eyebrow text-ink-muted mb-space-ds-intro-eyebrow-heading">
                06 · Treatments
              </div>
              <h2 className="text-ds-section font-medium text-ink max-w-[520px]">
                Focused options, honestly explained.
              </h2>
            </div>
          </div>

          <div className="border-t border-gray-200">
            {treatments.map((t) => {
              const isOpen = openId === t.id;
              return (
                <div key={t.id} className={`border-b border-gray-200 transition-colors ${isOpen ? "bg-brand-soft/40" : ""}`}>
                  <button
                    onClick={() => setOpenId(isOpen ? "" : t.id)}
                    className="w-full flex items-center gap-6 py-space-ds-list-row-lg md:py-space-ds-list-row-lg-md text-left cursor-pointer"
                  >
                    <span className={`w-10 md:w-14 text-ds-meta font-medium ${isOpen ? "text-brand" : "text-ink-faint"}`}>
                      {t.id}
                    </span>
                    <span className={`flex-1 text-ds-list-title uppercase tracking-[0.02em] ${isOpen ? "text-ink" : "text-ink"}`}>
                      {t.name}
                    </span>
                    <span className="hidden md:block text-ds-caption text-ink-muted mr-4">{t.tag}</span>
                    <span className={`w-10 h-10 flex items-center justify-center rounded-full transition ${isOpen ? "text-brand rotate-45" : "text-ink"}`}>
                      <i className="ri-add-line text-xl" />
                    </span>
                  </button>

                  <div
                    className={`grid transition-all duration-500 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                  >
                    <div className="overflow-hidden">
                      <div className="pb-8 md:pb-10 pl-10 md:pl-14 pr-10 md:pr-14 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                        <div className="md:col-span-5">
                          <div className="w-full max-w-[88%] aspect-[4/3] rounded-editorial overflow-hidden bg-page-cool">
                            <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                          </div>
                        </div>
                        <div className="md:col-span-4">
                          <div className="text-[16px] leading-[1.4] text-ink font-semibold mb-space-ds-intro-eyebrow-heading">{t.tag}</div>
                          <div className="text-ds-body-sm text-ink-muted mb-space-ds-tight-stack"><span className="text-ink-faint">Suits · </span>{t.suits}</div>
                          <div className="text-ds-body-sm text-ink-faint"><span className="text-ink-faint">Typical timeline · </span>{t.timeline}</div>
                        </div>
                        <div className="md:col-span-3">
                          <div className="text-ds-eyebrow tracking-[0.2em] text-brand mb-space-ds-tight-stack">Craft & Technology</div>
                          <div className="text-ds-body-sm text-ink-muted mb-space-ds-intro-heading-body">{t.tech}</div>
                          <a href="#contact" className="inline-flex items-center gap-2 text-ds-control text-ink border-b border-ink pb-0.5 hover:text-brand hover:border-brand transition cursor-pointer">
                            View Treatment <i className="ri-arrow-right-line" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}